import { useFilters } from '@spotify/confidence-core-react';
import { CollectionsV1ResourceType } from '@spotify/confidence-graphql';
import { useCurrentIdentity } from '@spotify/plugin-confidence-iam-react';

import { FAVORITES_FILTER } from '../../components/FavoritesFilterToggle';
import { deriveFavoritesCollectionName } from '../../utils';
import { useAsyncCombinedFilter } from '../useAsyncCombinedFilter';
import { useCollectionResourcesFilter } from '../useCollectionResourcesFilter';

export const useFilterWithFavorites = (options: {
  resourceType: CollectionsV1ResourceType;
}): {
  filter: string;
  nameFiltersLoading: boolean;
  resolvedNameFilterEmpty: boolean;
} => {
  const { filterString, activeFilters } = useFilters();
  const showFavoritesOnly = activeFilters.some(
    f => f.id === FAVORITES_FILTER.id,
  );

  const { currentIdentity, isLoading: identityLoading } = useCurrentIdentity();
  const favoritesCollectionName = currentIdentity?.name
    ? deriveFavoritesCollectionName(currentIdentity.name)
    : null;

  const { nameFilter, loading: filterLoading } = useCollectionResourcesFilter(
    showFavoritesOnly ? favoritesCollectionName : null,
    { resourceType: options.resourceType },
  );

  const loading = identityLoading || filterLoading;

  return useAsyncCombinedFilter(filterString, [
    { nameFilter, loading, active: showFavoritesOnly },
  ]);
};
